var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Compras por Proveedor")]),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" Próximamente")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }